import Enum from "../../../enums/Enum";

const InsuranceReferralStatus = new Enum({
    PENDING: {name: "Pending"},
    REQUESTED: {name: "Requested"},
    APPROVED: {name: "Approved"},
    DENIED: {name: "Denied"},
    COMPLETED: {name: "Completed"},
    CANCELLED: {name: "Cancelled"},
    EXPIRED: {name: "Expired"},
    EDIT: {name: "Edit"},
});

export default InsuranceReferralStatus;
